<template>
    <div class="container-fluid" >
        <button @click="$router.go(-1)" class="btn btn-primary mt-3 mb-3">
            <font-awesome-icon :icon="['fa', 'arrow-left']"/>
            Voltar
        </button>
        <button @click="getDetail" class="btn btn-primary ml-3 mt-3 mb-3">
            <font-awesome-icon :icon="['fa', 'retweet']"/>
            Atualizar
        </button>
        <div>
            <div class="detail-container">
                <div class="row">
                    <div class="col-md-12">
                        <!-- Arquivo pequeno - exibir inline -->
                        <iframe v-if="loaded && !isLargeFile"
                                width="100%"
                                height="1000"
                                :src="'data:application/pdf;base64, ' + pdfDataUrl + ''"
                        ></iframe>
                        
                        <!-- Arquivo grande - mostrar mensagem de download -->
                        <div v-if="loaded && isLargeFile" class="text-center p-5">
                            <div class="alert alert-success">
                                <h4><i class="fa fa-check-circle"></i> Download Concluído</h4>
                                <p>{{ largeFileMessage }}</p>
                                <p><i class="fa fa-info-circle"></i> O arquivo foi baixado automaticamente para sua pasta de Downloads.</p>
                                <button @click="getDetail" class="btn btn-primary">
                                    <i class="fa fa-refresh"></i> Tentar Novamente
                                </button>
                            </div>
                        </div>
                        
                        <div class="card-body text-center" v-if="spinner">
                            <span class="fa fa-spinner fa-spin fa-5x"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loaded: false,
            spinner: true,
            data: {},
            pdfDataUrl: '',
            isLargeFile: false,
            largeFileMessage: ''
        };
    },
    computed: {
        positionTime() {
            return moment(this.map[0].PositionTime).format("DD/MM/YYYY H:m:s");
        },
    },
    methods: {
        getDetail() {
            const formData = this.$store.state.order_report;
            if (Object.keys(formData).length === 0) this.$router.push("/admin/order-list");

            const self = this;
            self.loaded = false;
            self.isLargeFile = false;

            var api = self.$store.getters.api + "order-report/";

            console.log(formData);

            // Usar arraybuffer para poder detectar tanto JSON quanto PDF
            axios
                .post(api, formData, { responseType: 'arraybuffer' })
                .then((response) => {
                    const contentType = response.headers['content-type'] || '';
                    
                    // Se for PDF (arquivo grande - stream download)
                    if (contentType.includes('application/pdf')) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        
                        // Criar link temporário para download
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = 'laudo.pdf';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                        
                        // Mostrar mensagem de sucesso
                        self.$toast.success('Download iniciado automaticamente!');
                        self.loaded = true;
                        self.isLargeFile = true;
                        self.largeFileMessage = 'Arquivo grande detectado. Download iniciado automaticamente.';
                        return;
                    }
                    
                    // Se for JSON (arquivo pequeno)
                    if (contentType.includes('application/json')) {
                        // Converter arraybuffer para string e depois parsear JSON
                        const decoder = new TextDecoder('utf-8');
                        const jsonString = decoder.decode(response.data);
                        const data = JSON.parse(jsonString);
                        
                        // Verificar se tem status (formato novo) ou laudo direto (formato antigo)
                        if (data.status === '00' && data.data && data.data.laudo) {
                            // Formato novo: { status: '00', data: { laudo: '...', filename: '...' } }
                            self.pdfDataUrl = data.data.laudo;
                            self.isLargeFile = false;
                            self.loaded = true;
                        } else if (data.laudo) {
                            // Formato direto: { laudo: '...', filename: '...' }
                            self.pdfDataUrl = data.laudo;
                            self.isLargeFile = false;
                            self.loaded = true;
                        } else if (data.status === '01') {
                            // Erro retornado pela service
                            const errorMessage = data.message || 'Este laudo não está disponível na plataforma, favor, entre em contato com o Atendimento.';
                            self.$toast.error(errorMessage);
                            self.loaded = false;
                        } else {
                            // Formato inesperado
                            console.error('Resposta inesperada:', data);
                            self.$toast.error('Erro ao processar resposta do servidor.');
                            self.loaded = false;
                        }
                        return;
                    }
                    
                    // Tipo de conteúdo não reconhecido
                    self.$toast.error('Tipo de resposta não reconhecido pelo sistema.');
                    self.loaded = false;
                })
                .catch((error) => {
                    // Se for erro 500, tentar extrair mensagem
                    if (error.response) {
                        const contentType = error.response.headers['content-type'] || '';
                        let errorMessage = 'Este laudo não está disponível na plataforma, favor, entre em contato com o Atendimento.';
                        
                        // Se a resposta for JSON
                        if (contentType.includes('application/json')) {
                            try {
                                let data = error.response.data;
                                
                                // Se for arraybuffer, converter para string
                                if (data instanceof ArrayBuffer) {
                                    const decoder = new TextDecoder('utf-8');
                                    const jsonString = decoder.decode(data);
                                    data = JSON.parse(jsonString);
                                }
                                
                                // Se a resposta for string (mensagem de erro)
                                if (typeof data === 'string') {
                                    errorMessage = data;
                                } 
                                // Se a resposta for objeto com message
                                else if (data && data.message) {
                                    errorMessage = data.message;
                                }
                            } catch (e) {
                                // Se não conseguir parsear, usar mensagem padrão
                            }
                        }
                        // Se a resposta for string (sem content-type JSON)
                        else if (typeof error.response.data === 'string') {
                            errorMessage = error.response.data;
                        }
                        // Se for arraybuffer, tentar converter
                        else if (error.response.data instanceof ArrayBuffer) {
                            try {
                                const decoder = new TextDecoder('utf-8');
                                const text = decoder.decode(error.response.data);
                                errorMessage = text || errorMessage;
                            } catch (e) {
                                // Usar mensagem padrão se não conseguir converter
                            }
                        }
                        
                        self.$toast.error(errorMessage);
                    } else {
                        self.$toast.error(
                            "Este laudo não está disponível na plataforma, favor, entre em contato com o Atendimento."
                        );
                    }
                    self.loaded = false;
                })
                .finally(() => {
                    self.spinner = false;
                })
        },
        
    },

    mounted() {
        const self = this;
        self.getDetail();
    },
};
</script>